import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Immobile } from '../../../../models';

@Component({
  selector: 'app-dialog-immobile-sospeso',
  templateUrl: './dialog-immobile-sospeso.component.html',
  styleUrls: ['./dialog-immobile-sospeso.component.css']
})
export class DialogImmobileSospeso implements OnInit {
  immobile: Immobile;

  constructor(public dialogRef: MatDialogRef<DialogImmobileSospeso>,
    @Inject(MAT_DIALOG_DATA) public data: Immobile) 
  {
    this.immobile = data;
  }

  ngOnInit() {}

  si(){
    this.dialogRef.close(true);
  }

}


// WEBPACK FOOTER //
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/components/utilita/dialogs/dialog-immobile-sospeso/dialog-immobile-sospeso.component.ts